<template>
    <div>
        <YesNoModal ref="YesNoModal" />
        <ErrorModal ref="ErrorModal"></ErrorModal>
        <Loader ref="Loader"></Loader>
        <v-container fluid grid-list-xs>
            <v-layout justify-center wrap>
                <v-flex md12>
                    <v-card>
                        <v-btn v-if="HasAccess('USER_MANAGEMENT', 'CREATE')" style="float:right;"
                            color="success --darken-2" @click="$router.push('/user/create')">
                            <v-icon>add</v-icon>
                            Add User
                        </v-btn>
                        <v-data-table :headers="headers" :items="items" :search="search"
                            :rows-per-page-items="[25,50,75,100]">
                            <template slot="no-data">
                                There are no records
                            </template>
                            <template slot="no-results">
                                No matching records found
                            </template>
                            <template slot="headerCell" slot-scope="{ header }">
                                <span class="subheading font-weight-light text-success text--darken-3"
                                    v-text="header.text" />
                            </template>
                            <template v-slot:items="props">
                                <td>{{ props.index+1 }}</td>
                                <td>{{ props.item.Title }}</td>
                                <td>{{ props.item.FirstName }}</td>
                                <td>{{ props.item.LastName }}</td>
                                <td>{{ props.item.RegionName }}</td>
                                <td>{{ props.item.RoleName }}</td>
                                <td>{{ props.item.InActive }}</td>
                                <td style="float:right;">
                                    <v-menu dense bottom left>
                                        <v-btn small slot="activator" color="primary" dark>
                                            <v-icon>settings</v-icon>
                                        </v-btn>

                                        <div
                                            v-if="HasAccess('USER_MANAGEMENT', 'MODIFY') || HasAccess('USER_MANAGEMENT', 'DELETE')">
                                            <v-list dense v-for="(action, index) in actionItems" :key="index">
                                                <v-list-tile @click="PerformOperation(action, props.item)"
                                                    v-if="action.access == true">
                                                    <v-list-tile-action>
                                                        <v-icon color="primary darken-2">{{ action.icon }}</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-title>{{ action.title }}</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </div>
                                        <div v-else>
                                            <v-list dense>
                                                <v-list-tile>
                                                    <v-list-tile-title>You have no options
                                                        available</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </div>
                                    </v-menu>
                                </td>
                            </template>
                        </v-data-table>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
        data() {
            let self = this;

            return {
                actionItems: [{
                        type: 'modify',
                        title: 'Modify',
                        access: self.HasAccess('USER_MANAGEMENT', 'MODIFY'),
                        icon: 'edit'
                    },
                    {
                        type: 'delete',
                        title: 'Delete',
                        access: self.HasAccess('USER_MANAGEMENT', 'DELETE'),
                        icon: 'delete'
                    }
                ],
                headers: [
                    {

                    },
                    {
                        sortable: true,
                        text: 'Title',
                        value: 'Title'
                    },
                    {
                        sortable: true,
                        text: 'First name',
                        value: 'FirstName'
                    },
                    {
                        sortable: true,
                        text: 'Last name',
                        value: 'LastName'
                    },
                    {
                        sortable: true,
                        text: 'Region',
                        value: 'RegionName'
                    },
                    {
                        sortable: true,
                        text: 'Role',
                        value: 'RoleName'
                    },
                    {
                        sortable: true,
                        text: 'In-Active',
                        value: 'InActive'
                    },
                    {
                        sortable: false,
                        align: 'right',
                        text: 'Actions'
                    }
                ],
                items: [],
                regionItems: [],
                role: null,
                userID: null
                // search: null
            }
        },
        props: {
            search: String,
            accountID: Number
        },
        mounted() {
            let self = this;
            self.userID = localStorage.getItem("USER_ID");
            self.role = localStorage.getItem("Role");
            console.log("USER_ID", self.userID)
            console.log("ROLE", self.role)

            self.FetchData();
        },
        methods: {
            FetchData() {
                let self = this;
                let url;
                self.items = [];

                self.$refs.Loader.show();
                self.$refs.Loader.setText('Loading users...');
                self.get(`SystemUser/getAll`)
                    .then(response => {
                        self.$refs.Loader.hide();
                        console.log(response.data)
                        if (response.data.length >= 1) {
                            self.items = response.data;

                        } else {
                            self.items.push(response.data)
                        }
                    })
                    .catch(error => {
                        self.$refs.Loader.hide();
                        self.$refs.ErrorModal.show();
                        self.$refs.ErrorModal.setText(error.toString());
                    })
            },
            PerformOperation(action, item) {
                let self = this;
                switch (action.type.toUpperCase()) {
                    case "MODIFY": {
                        self.modifyitem(item);
                    }
                    break;
                case "DELETE": {
                    self.deleteItem(item);
                }
                break;
                }
            },
            modifyitem(item) {
                let self = this;

                self.$router.push('/user/modify/' + item.ID);
            },
            deleteItem(item) {
                let self = this;

                item.IsDeleted = true;
                let Request = item;

                self.$refs.YesNoModal.show('Are you sure you want to delete this user?', function (
                    yes) {
                    if (yes == true) {
                        self.$refs.Loader.show(true);
                        self.$refs.Loader.setText('Deleting user...');
                        self.put(`SystemUser?id=${item.ID}`, Request)
                            .then(result => {
                                self.$refs.Loader.hide();
                                if (result.data == true) {
                                    var index = self.items.indexOf(item);
                                    if (index > -1) {
                                        self.items.splice(index, 1);
                                    }
                                }
                            })
                            .catch(error => {
                                self.$refs.Loader.hide();
                                self.$refs.ErrorModal.show();
                                self.$refs.ErrorModal.setText(error.toString());
                            })
                    }
                })
            }
        }
    }
</script>